// Features/Paired-Quantity/mod.ts
var Selector_Template = `template[ data-type = Paired-Quantity ]`;

class CustomElement extends HTMLElement {
  slot_quantity;
  slot_price;
  slot_unit;
  formatter;
  constructor() {
    super();
    const { currency, locale } = Shopify;
    this.formatter = new Intl.NumberFormat(locale, {
      currency: currency.active,
      style: "currency"
    });
    const { content } = document.querySelector(Selector_Template);
    const shadow = this.attachShadow({ mode: "open" });
    shadow.appendChild(content.cloneNode(true));
    this.slot_quantity = shadow.querySelector(".Quantity");
    this.slot_price = shadow.querySelector(".Price");
    this.slot_unit = shadow.querySelector(".Unit");
  }
  toMoney(value) {
    return this.formatter.format(value * 0.01);
  }
  set quantity(value) {
    this.slot_quantity.innerText = String(value);
  }
  set price(value) {
    this.slot_price.innerText = this.toMoney(value);
  }
  set unit(value) {
    this.slot_unit.innerText = value;
  }
}
customElements.define("paired-quantity", CustomElement);
